import React from "react";

import estilo from "./styles/Opciones.module.css";
import { useNavigate } from "react-router-dom";

function Opciones() {
  let navigate = useNavigate();

  return (
    <div className={estilo.opciones}>
      <ul>
        <li onClick={() => navigate("/perfil")}>
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path d="M12 2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm9 11v-1a7 7 0 0 0-7-7h-4a7 7 0 0 0-7 7v1h2v-1a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5v1z"></path>
          </svg>
          <p>Perfil</p>
        </li>

        <li onClick={() => navigate("/")}>
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path d="M18 17c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H6c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12zM4 19h16v2H4z"></path>
          </svg>
          <p>Encuentro</p>
        </li>

        <li onClick={() => navigate("/usuarios")}>
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM6.435 8.467A1.49 1.49 0 0 1 8.502 8.4a1.49 1.49 0 0 1 2.065.033c.597.592.604 1.521.018 2.118l-2.05 2.083-2.082-2.05a1.484 1.484 0 0 1-.018-2.117zM12 18c-4 0-5-4-5-4h10s-1 4-5 4zm5.585-7.449-2.05 2.083-2.082-2.05a1.485 1.485 0 0 1-.019-2.117 1.49 1.49 0 0 1 2.068-.067 1.49 1.49 0 0 1 2.065.033c.597.591.605 1.521.018 2.118z"></path>
          </svg>
          <p>Usuarios</p>
        </li>

        <li onClick={() => navigate("/contactos")}>
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path d="M21 2H6a2 2 0 0 0-2 2v3H2v2h2v2H2v2h2v2H2v2h2v3a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-8 2.999c1.648 0 3 1.351 3 3A3.012 3.012 0 0 1 13 11c-1.647 0-3-1.353-3-3.001 0-1.649 1.353-3 3-3zM19 18H7v-.75c0-2.219 2.705-4.5 6-4.5s6 2.281 6 4.5V18z"></path>
          </svg>
          <p>Contactos</p>
        </li>
      </ul>
    </div>
  );
}

export default Opciones;
